export enum OfferPriceType {
    NETTO = 1,
    BRUTTO = 2
}
export enum OfferPriceType {
    NETTO = 1,
    BRUTTO = 2
}
